import { useQuery } from "@tanstack/react-query";
import { useLocalLogic } from "~/context/LocalLogicProvider";
import { profilesKeys } from "~/features/profiles";

type ProfilesParams = {
  location: {
    lat?: number;
    lng?: number;
  };
  geogID?: string;
  externalId?: string;
};

export function useProfiles({ location, geogID, externalId }: ProfilesParams) {
  const { client } = useLocalLogic();

  const fetchProfiles = async () => {
    const response = await client.getProfiles({
      ...(geogID
        ? {
            geogId: geogID,
          }
        : {
            lat: location.lat,
            lng: location.lng,
          }),
      externalId,
    });

    return response;
  };

  return useQuery({
    queryKey: profilesKeys.list(location!),
    queryFn: fetchProfiles,
    enabled: (!!location && !!location.lat && !!location.lng) || !!geogID,
  });
}
